import '../../picker/style/';
// tslint:disable-next-line:ordered-imports
import '../../icon/style/';
import './index.less';
